// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-popup {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #242b37;
  border: 0.1vw solid #00ffff;
  border-radius: 8px;
  padding: 16px 24px;
  box-shadow: 
    0 0 10px rgba(0, 255, 255, 0.3),
    0 0 20px rgba(0, 255, 255, 0.2),
    inset 0 0 8px rgba(0, 255, 255, 0.2);
  z-index: 1000;
  animation: slideUp 0.3s ease-out, dialogueGlow 2s ease-in-out infinite;
}

.simple-popup-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.simple-popup-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border: 2px solid #00ffff;
  border-radius: 50%;
  padding: 4px;
  padding-left: 6px;
  animation: pulse 2s infinite;
}

.simple-popup-text-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.simple-popup-header {
  color: #00ffff;
  font-size: 1rem;
  margin: 0;
  font-family: Kim;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.simple-popup-text {
  color: #e0e0e0;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.game-notification-subtext {
  /* color: #a0a0a0; */
  font-size: 0.9rem;
  margin: 0;
  font-weight: 700;
}

@keyframes slideUp {
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

@keyframes dialogueGlow {
  0% {
    box-shadow: 
      0 0 10px rgba(0, 255, 255, 0.3),
      0 0 20px rgba(0, 255, 255, 0.2),
      inset 0 0 8px rgba(0, 255, 255, 0.2);
  }
  50% {
    box-shadow: 
      0 0 15px rgba(0, 255, 255, 0.4),
      0 0 30px rgba(0, 255, 255, 0.3),
      inset 0 0 12px rgba(0, 255, 255, 0.3);
  }
  100% {
    box-shadow: 
      0 0 10px rgba(0, 255, 255, 0.3),
      0 0 20px rgba(0, 255, 255, 0.2),
      inset 0 0 8px rgba(0, 255, 255, 0.2);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0);
  }
}

@media (max-width: 768px) {
  .simple-popup {
    width: 90%;
    padding: 12px 16px;
  }
  
  .simple-popup-text {
    font-size: 1rem;
  }
}

/* Add a subtle hover effect */
.simple-popup:hover {
  transform: translate(-50%, -2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
  transition: all 0.2s ease;
}

.highlight-text {
  color: #00ffff;
  font-weight: 700;
}
.gold-icon {
  width: 16px;
  height: 16px;
  margin-right: 0;
  margin-bottom: -2px;
} `, "",{"version":3,"sources":["webpack://./src/components/popups/simplePopup/SimplePopup.style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB;;;wCAGsC;EACtC,aAAa;EACb,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;EACE;IACE;;;0CAGsC;EACxC;EACA;IACE;;;2CAGuC;EACzC;EACA;IACE;;;0CAGsC;EACxC;AACF;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,gCAAgC;EAChC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".simple-popup {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #242b37;\n  border: 0.1vw solid #00ffff;\n  border-radius: 8px;\n  padding: 16px 24px;\n  box-shadow: \n    0 0 10px rgba(0, 255, 255, 0.3),\n    0 0 20px rgba(0, 255, 255, 0.2),\n    inset 0 0 8px rgba(0, 255, 255, 0.2);\n  z-index: 1000;\n  animation: slideUp 0.3s ease-out, dialogueGlow 2s ease-in-out infinite;\n}\n\n.simple-popup-content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.simple-popup-icon {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  border: 2px solid #00ffff;\n  border-radius: 50%;\n  padding: 4px;\n  padding-left: 6px;\n  animation: pulse 2s infinite;\n}\n\n.simple-popup-text-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.simple-popup-header {\n  color: #00ffff;\n  font-size: 1rem;\n  margin: 0;\n  font-family: Kim;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.simple-popup-text {\n  color: #e0e0e0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.game-notification-subtext {\n  /* color: #a0a0a0; */\n  font-size: 0.9rem;\n  margin: 0;\n  font-weight: 700;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translate(-50%, 100%);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n\n@keyframes dialogueGlow {\n  0% {\n    box-shadow: \n      0 0 10px rgba(0, 255, 255, 0.3),\n      0 0 20px rgba(0, 255, 255, 0.2),\n      inset 0 0 8px rgba(0, 255, 255, 0.2);\n  }\n  50% {\n    box-shadow: \n      0 0 15px rgba(0, 255, 255, 0.4),\n      0 0 30px rgba(0, 255, 255, 0.3),\n      inset 0 0 12px rgba(0, 255, 255, 0.3);\n  }\n  100% {\n    box-shadow: \n      0 0 10px rgba(0, 255, 255, 0.3),\n      0 0 20px rgba(0, 255, 255, 0.2),\n      inset 0 0 8px rgba(0, 255, 255, 0.2);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(0, 255, 255, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 255, 255, 0);\n  }\n}\n\n@media (max-width: 768px) {\n  .simple-popup {\n    width: 90%;\n    padding: 12px 16px;\n  }\n  \n  .simple-popup-text {\n    font-size: 1rem;\n  }\n}\n\n/* Add a subtle hover effect */\n.simple-popup:hover {\n  transform: translate(-50%, -2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n  transition: all 0.2s ease;\n}\n\n.highlight-text {\n  color: #00ffff;\n  font-weight: 700;\n}\n.gold-icon {\n  width: 16px;\n  height: 16px;\n  margin-right: 0;\n  margin-bottom: -2px;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
